import $ from "jquery";
export type ExistsElement = (selector: string) => boolean;
export type ExistsChildElement = (
  selector: string,
  childSelector: string
) => boolean;
export type SetTextToElement = (selector: string, text: string) => void;
export type SetContentToElement = (selector: any, content: string) => void;
export type FormattedPrice = (price: number) => string;
export type SetAttribute = (selector: any, name: string, value: string) => void;
export type RemoveAttribute = (selector: any, name: string) => void;
export type GetTextContent = (selector: string) => string;
export type GetInputValue = (selector: any) => string | number | string[];
export type SetInputValue = (
  selector: any,
  value: string | number | string[]
) => void;
export type AddEvent = (
  selector: any,
  event: string,
  handler: any,
  data?: Record<string, unknown>
) => void;
export type RemoveEvent = (selector: any, event: string) => void;
export type FindParentElement = (
  selector: any,
  parentSelector: string
) => JQuery<HTMLElement> | null;
export type AddElementClass = (selector: any, className: string) => void;
export type RemoveElementClass = (selector: any, className: string) => void;
export type SetStyle = (
  selector: any,
  styles: { [key: string]: number | string }
) => void;

/**
 * 要素が存在するかどうか
 *
 * @param  selector 存在の確認を行う要素のセレクタ
 * @returns 要素が存在するかどうか
 */
export const existsElement: ExistsElement = (selector) => {
  const element = document.querySelector(selector);
  return element !== null;
};

/**
 * 指定した要素の子要素の存在確認を行う
 *
 * @param selector 指定した要素
 * @param childSelector 子要素
 * @returns 指定した要素の子要素が存在するかどうか
 */
export const existsChildElement: ExistsChildElement = (
  selector,
  childSelector
) => $(selector).find(childSelector).length > 0;

/**
 * 指定した要素のテキストを書き換える

 * @param selector 指定した要素
 * @param text 書き換えるテキスト
 */
export const setTextToElement: SetTextToElement = (selector, text) => {
  $(selector).text(text);
};

/**
 * 指定した要素のHTMLコンテンツを書き換える

 * @param selector 指定した要素
 * @param content 書き換えるテキスト
 */
export const setContentToElement: SetContentToElement = (selector, content) => {
  $(selector).html(content);
};

/**
 * 3桁区切りでカンマを付与した価格を返す
 * @param price
 */
export const formattedPrice: FormattedPrice = (price) => {
  return price.toLocaleString("ja-JP");
};

/**
 * 要素に属性を付与する
 *
 * @param selector 指定した要素
 * @param name 属性名
 * @param value 属性にセットする値
 */
export const setAttribute: SetAttribute = (selector, name, value) => {
  $(selector).attr(name, value);
};

/**
 * 要素の属性を削除する
 *
 * @param selector 指定した要素
 * @param name 属性名
 */
export const removeAttribute: RemoveAttribute = (selector, name) => {
  $(selector).removeAttr(name);
};

/**
 * 要素内のテキストのみを取得する
 *
 * @param selector 指定した要素
 */
export const getTextContent: GetTextContent = (selector) => $(selector).text();

/**
 * 指定した要素の値を取得する
 *
 * @param selector 指定した要素
 */
export const getInputValue: GetInputValue = (selector) => {
  const value = $(selector).val();
  return value !== undefined ? value : "";
};

/**
 * 指定した要素の値を更新する
 *
 * @param selector 指定した要素
 * @param value 要素にセットする値
 */
export const setInputValue: SetInputValue = (selector, value) => {
  $(selector).val(value);
};

/**
 * 要素にイベントをバインドする
 *
 * @param selector 指定した要素
 * @param events イベント
 * @param handler イベントハンドラ関数
 * @param data イベントに渡すデータ
 */
export const addEvent: AddEvent = (selector, events, handler, data = {}) => {
  $(selector).on(events, data, handler);
};

/**
 * 要素にバインドされたイベントを削除する
 *
 * @param selector 指定した要素
 * @param events イベント
 */
export const removeEvent: RemoveEvent = (selector, events) => {
  $(selector).off(events);
};

/**
 * 指定した要素の直近の親要素を取得する
 *
 * @param selector 指定した要素
 * @param parentSelector 親要素
 */
export const findParentElement: FindParentElement = (
  selector,
  parentSelector
) => {
  const $element = $(selector).closest(parentSelector);
  return $element.length !== 0 ? $element : null;
};

/**
 * 指定した要素にクラスを付与する
 *
 * @param selector 指定した要素
 * @param className 追加するクラス名
 */
export const addElementClass: AddElementClass = (selector, className) => {
  $(selector).addClass(className);
};

/**
 * 指定した要素からクラスを取り除く
 *
 * @param selector 指定した要素
 * @param className 取り除くするクラス名
 */
export const removeElementClass: RemoveElementClass = (selector, className) => {
  $(selector).removeClass(className);
};

/**
 * 要素にスタイルを付与する
 *
 * @param selector 指定した要素
 * @param styles スタイル
 */
export const setStyle: SetStyle = (selector, styles) => {
  $(selector).css(styles);
};
